import { inject, Injectable } from '@angular/core';
import { AppRoutes } from '@core/routes/route.paths';
import { MasterlockService } from '@features/masterlock/services/masterlock.service';
import { SubMenu } from '@shared/model/menu-item.type';

@Injectable({ providedIn: 'root' })
export class MasterLockMenuService {
  readonly #masterlockService = inject(MasterlockService);

  getMenu(): SubMenu {
    return {
      root: { label: 'main-menu.masterlock', routerLink: this.#masterlockService.masterLockRoute() },
      items: [
        {
          label: 'menu.supervision',
          routerLink: AppRoutes.GestionBaseDonnees.Supervision,
          show: () => this.#masterlockService.canShowSupervision(),
        },
        {
          label: 'menu.file',
          routerLink: AppRoutes.GestionBaseDonnees.Csv,
          show: () => this.#masterlockService.canShowCSV(),
        },
      ],
    };
  }
}
